module.exports = __webpack_public_path__ + "static/img/20005 (1).c17e907.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20005 (1).webp
// module id = hH+4
// module chunks = 14